/**
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */


import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';

import {POPOVER_DIRECTIVES} from './index';
export class ClrCommonPopoverModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{imports: [CommonModule], declarations: [POPOVER_DIRECTIVES], exports: [POPOVER_DIRECTIVES]}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ClrCommonPopoverModule_tsickle_Closure_declarations() {
/** @type {?} */
ClrCommonPopoverModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ClrCommonPopoverModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
